module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0148.jpg?v=55d18cae";